<template>
    <div class="con-btn">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>发货单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="block-container">
            <div class="content-caption dashed">
                <span>配货信息</span>
            </div>

            <div class="form-single mt20 mb20">
                <div class="title required">配货单</div>
                <div class="content">
                    <div class="pos-rel" style="width: 640px">
                        <el-input class="bottom-line width-4x" style="width: 100%;" :disabled="true" v-model="shipVoucher.allocFormTitle"></el-input>
                        <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectAllocForm()"></i>
                    </div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">客户名称</div>
                <div class="content">
                    <el-input class="bottom-line width-4x" :disabled="true" v-model="shipVoucher.buyerName"></el-input>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">业务单元</div>
                <div class="content">
                    <el-input class="bottom-line width-4x" :disabled="true" v-model="shipVoucher.buyerShopName"></el-input>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">所属部门</div>
                <div class="content">
                    <el-input class="bottom-line width-4x" :disabled="true" v-model="shipVoucher.buyerBizUnitName"></el-input>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">收货地址</div>
                <div class="content">
                    <el-input class="bottom-line width-4x" :disabled="true" v-model="shipVoucher.buyerRecvAddr"></el-input>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">收货人</div>
                <div class="content">
                    <el-input class="bottom-line  width-4x" :disabled="true" v-model="shipVoucher.buyerRecvContractName"></el-input>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">联系电话</div>
                <div class="content">
                    <el-input class="bottom-line  width-4x" :disabled="true" v-model="shipVoucher.buyerRecvContactTel"></el-input>
                </div>
            </div>

            <div class="content-caption dashed bg-white">
                <span>物流信息</span>
            </div>
            <el-form :rules="validateRules">
                <div class="form-single" style="overflow: visible;margin-bottom: 15px">
                    <div class="title required">发货人</div>
                    <div class="content">
                        <el-form-item class="mr20" prop="senderContactName">
                            <el-input class="width-1-5x" v-model="shipVoucher.senderContactName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-single" style="overflow: visible;margin-bottom: 15px">
                    <div class="title required">发货人联系方式</div>
                    <div class="content">
                        <el-form-item class="mr20" prop="senderContactTel">
                            <el-input class="width-1-5x" v-model="shipVoucher.senderContactTel"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-single" style="overflow: visible;margin-bottom: 15px">
                    <div class="title">要求到货日期</div>
                    <div class="content">
                        <span>{{desireArriveDate || '无'}}</span>
                    </div>
                </div>
                <div class="form-single" style="overflow: visible;margin-bottom: 15px">
                    <div class="title required">预计到货日期</div>
                    <div class="content">
                        <el-form-item class="mr20" prop="expectArriveDate">
                            <el-date-picker v-model="shipVoucher.expectArriveDate " :picker-options="pickerOptions0" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <div class="form-single mt20 mb20">
                <div class="title">公司名称</div>
                <div class="content">
                    <div class="pos-rel" style="width: 640px">
                        <el-input class="bottom-line width-4x" style="width: 100%;" :disabled="true" v-model="shipVoucher.logisComName"></el-input>
                        <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="showLogisCom()"></i>
                    </div>
                </div>
            </div>
            <div class="form-single mt20 mb20">
                <div class="title">公司代码</div>
                <div class="content">
                    <div class="pos-rel" style="width: 600px">
                        <el-input class="bottom-line width-4x" style="width: 100%;" :disabled="true" v-model="shipVoucher.logisComCode"></el-input>
                    </div>
                </div>
            </div>
            <el-form :rules="logisExpNoRules" ref="logisExpNo">
                <div class="form-single mt20 mb20" style="overflow: visible;margin-bottom: 15px;">
                    <div class="title">物流单号</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 600px">
                            <el-form-item class="pr20" prop="logisExpNo">
                                <el-input class="bottom-line width-4x" style="width: 100%;" v-model="shipVoucher.logisExpNo" placeholder="请输入物流单号"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="form-single mt20 mb20" style="overflow: visible;margin-bottom: 15px;">
                    <div class="title">物流费用(元)</div>
                    <div class="content">
                        <div class="pos-rel" style="width: 600px">
                            <el-form-item class="pr20" prop="logisFee">
                                <el-input class="bottom-line width-4x" style="width: 100%;" type="text" v-model.number="shipVoucher.logisFee" placeholder="请输入物流费用"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </el-form>

            <div class="content-caption dashed bg-white">
                <span>商品信息</span>
            </div>
            <div class="table-layout">
                <el-form :model="shipVoucher" ref="shipVoucher">
                    <el-table :data="shipVoucher.itemList" border style="width: 100%">
                        <el-table-column align="left" width="200" prop="title" label="商品名称"></el-table-column>
                        <el-table-column align="left" width="150" prop="catName" label="分类名称"></el-table-column>
                        <el-table-column align="left" width="150" prop="brandName" label="品牌名称"></el-table-column>
                        <el-table-column align="center" width="100" prop="vendorUknoFlag" label="提供商品标识码">
                            <template slot-scope="rows">
                                <input type="checkbox" v-model="rows.row.vendorUknoFlag"/>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="100" prop="price" label="含税价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="100" prop="taxRate" label="税率(%)">
                            <template slot-scope="rows">
                                <!--<input class="align-right" style="width: 100%;" type="number" :min="0" v-model="rows.row.taxRate" @change="taxRateChange(rows.row)"/>-->
                                <span v-if="rows.row.ntxPrice != null">{{rows.row.taxRate || 0}}</span>
                                <span v-else>0</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="ntxPrice" label="未税价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxPrice != null">{{rows.row.ntxPrice.toFixed(2)}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="150" prop="amount" label="费用小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.price != null && rows.row.quantity != null">{{rows.row.price * rows.row.quantity}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" width="150" prop="ntxAmount" label="未税小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.price != null && rows.row.taxRate != null">{{(rows.row.price / (1 + (rows.row.taxRate * 0.01))).toFixed(2) * rows.row.quantity}}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="wrntPeriod" class="required" label="质保期(月)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.orderFlag">{{rows.row.wrntPeriod || 0}}</span>
                                <input v-else class="align-right" style="width: 100%;" type="number" :min="0" v-model="rows.row.wrntPeriod" @change="wrntPeriodChange(rows.row)"/>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" width="100" prop="quantity" label="配货数量"></el-table-column>
                        <el-table-column align="right" width="100" prop="quantity" label="发货数量"></el-table-column>
                        <el-table-column align="center" width="80" prop="unit" label="单位"></el-table-column>
                        <el-table-column align="left" width="200" prop="desc" label="说明"></el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="goBack">取消</button>
            <button class="swb-btn swb-btn-small" @click="saveShipVoucher">发货</button>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { openGoodsAllocFromListSelectDlg } from './selectDlg'

    import goodsDelivApi from '../../api/goodsDeliv'
    import goodsOrderApi from '../../api/goodsOrder'
    import userApi from '../../api/user'

    import SwbMerchantLogisComListForSelect from '../logisCom/MerchantLogisComListForSelect';
    Vue.regist(SwbMerchantLogisComListForSelect);

    import SwbGoodsShipVoucherList from './GoodsShipVoucherList';
    Routes.add(SwbGoodsShipVoucherList);

    import SwbShowGoodsOrder from './ShowGoodsOrder';
    Routes.add(SwbShowGoodsOrder);

    export default {
        name: 'swb-goods-ship-voucher-add',
        path: '/to/goods/ship/voucher/create',
        avlActions: '',
        avlScopes: 'vendor',
        notAsResc: true,
        authen: false,
        desc: '发货单创建',
        data: function () {
            let self = this;
            // 校验
            let validateSenderContactName = function (rule, value, callback) {
                let senderContactName = self.shipVoucher.senderContactName;
                if(Utils.isNoB(senderContactName)) {
                    callback(new Error('请输入发货人'));
                } else {
                    callback();
                }
            };
            let validateSenderContactTel = function (rule, value, callback) {
                let senderContactTel = self.shipVoucher.senderContactTel;
                if(!Utils.isNoB(senderContactTel)) {
                    if(!Utils.isPhoneNo(senderContactTel)) {
                        callback(new Error('请输入正确的发货人电话'));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error('请输入发货人电话'));
                }
            };
            let validateExpectArriveDate = function (rule, value, callback) {
                let expectArriveDate = self.shipVoucher.expectArriveDate;
                if(Utils.isNoB(expectArriveDate)) {
                    callback(new Error('请选择预计到货日期'));
                } else {
                    callback();
                }
            };
            let validateLogisExpNo = function (rule, value, callback) {
                let reg = /^[0-9a-zA-Z]*$/g;
                let regx = /\d+/;
                let logisComCode = self.shipVoucher.logisComCode || null;
                if(!Utils.isNoB(logisComCode)) {
                    let logisExpNo = self.shipVoucher.logisExpNo;
                    if(Utils.isNoB(logisExpNo)) {
                        callback(new Error('请输入物流单号'));
                    } else {
                        if(!reg.test(logisExpNo) || !regx.test(logisExpNo)) {
                            callback(new Error('物流单号只能是数字或字母和数字组成'));
                        } else {
                            callback();
                        }
                    }
                } else {
                    callback();
                }
            };
            let validateLogisFee = function (rule, value, callback) {
                let logisFee = self.shipVoucher.logisFee;
                if(Utils.isNoB(logisFee)) {
                    callback(new Error('请输入物流费用'));
                } else {
                    if(!Utils.isMoneyStr(logisFee, true)) {
                        callback(new Error('请输入正确的物流费用'));
                    } else if(logisFee < 0) {
                        callback(new Error('请输入正确的物流费用'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                // 发货单
                shipVoucher: {
                    // 预计到货日期
                    expectArriveDate: null,
                    senderContactName: null,
                    senderContactTel: null,
                    itemList: []
                },
                orderId: null,
                cancelledFlag: null,
                // 要求到货日期
                desireArriveDate: null,
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                //
                currMerchantId: null,
                currBizUnionId: null,
                // 校验
                validateRules: {
                    expectArriveDate: [{validator: validateExpectArriveDate, trigger: 'blur'}],
                    senderContactTel: [{validator: validateSenderContactTel, trigger: 'blur'}],
                    senderContactName: [{validator: validateSenderContactName, trigger: 'blur'}]
                },
                logisExpNoRules: {
                    logisExpNo: [{validator: validateLogisExpNo, trigger: 'blur'}],
                    logisFee: [{validator: validateLogisFee, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            //
            let self = this;
            let orderId = this.$route.query.orderId;
            this.orderId = Utils.isNoB(orderId) ? null : parseInt(orderId);
            let cancelledFlag = this.$route.query.cancelledFlag;
            this.cancelledFlag = Utils.isNoB(cancelledFlag) ? null : cancelledFlag;
            //
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type == 'info') {
                    self.currMerchantId = result.data.scopeEntity.id;
                    self.currBizUnionId = result.data.scopeEntity.bizUnionId;
                    self.shipVoucher.senderContactName = result.data.scopeEntity.staffName;
                    self.shipVoucher.senderContactTel = result.data.scopeEntity.staffContactTel;
                    self.shipVoucher = Utils.merge({}, self.shipVoucher);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        methods: {
            // 质保期校验
            wrntPeriodChange: function (shipVoucherItem) {
                let wrntPeriod = shipVoucherItem.wrntPeriod;
                if(!Utils.isNaturalStr(wrntPeriod)) {
                    shipVoucherItem.wrntPeriod = null;
                    MsgBox.warning("质保期必须为大于等于0的整数!");
                }
            },
            // 税率校验
            taxRateChange: function (shipVoucherItem) {
                let taxRate = shipVoucherItem.taxRate;
                if(Utils.isNoB(taxRate)) {
                    MsgBox.warning("请输入税率！");
                } else {
                    if(!Utils.isMoneyStr(taxRate)) {
                        MsgBox.warning("请输入正确的税率！");
                    } else if(taxRate < 0) {
                        MsgBox.warning("请输入正确的税率！");
                    } else {
                        shipVoucherItem.ntxPrice = ( shipVoucherItem.price / (1 + (shipVoucherItem.taxRate * 0.01))).toFixed(2);
                    }
                }
            },
            // 选择配货单
            selectAllocForm: function () {
                let self = this;
                let params = {
                    orderFlag: Utils.isNoB(self.orderId) ? null : true,
                    orderId: self.orderId,
                    state: getEnumInfoWith('allocFormState', 'name', 'Send').value,
                    checkedItem: {
                        id: self.shipVoucher.allocFormId
                    }
                };
                openGoodsAllocFromListSelectDlg(params, function (result) {
                    let shipVoucher = self.shipVoucher;
                    shipVoucher.allocFormId = result.id;
                    shipVoucher.allocFormTitle = result.title;
                    shipVoucher.buyerId = result.buyerId;
                    shipVoucher.buyerName = result.buyerName;
                    shipVoucher.buyerShopId = result.buyerShopId;
                    shipVoucher.buyerShopName = result.buyerShopName;
                    shipVoucher.buyerBizUnitName = result.buyerBizUnitName;
                    shipVoucher.buyerRecvRegionId = result.buyerRecvRegionId;
                    shipVoucher.buyerRecvAddr = result.buyerRecvAddr;
                    shipVoucher.buyerRecvContractName = result.buyerRecvContractName;
                    shipVoucher.buyerRecvContactTel = result.buyerRecvContactTel;
                    self.shipVoucher = Utils.merge({}, shipVoucher);
                    self.getAllocItemList(result.id);
                });
            },
            // 获取配货条目信息
            getAllocItemList: function (allocFormId) {
                let self = this;
                let params = {
                    id: allocFormId
                };
                goodsOrderApi.getOrderGoodsAllocItemListByAllocFormId(params, function (result) {
                    if(result.type == "info") {
                        let allocItemList = result.data || [];
                        //
                        let itemList = [];
                        let desireArriveDate = null;
                        for(let i = 0; i < allocItemList.length; i++) {
                            let allocItem = allocItemList[i];
                            desireArriveDate = allocItem.desireArriveDate;
                            let item = {
                                allocFormItemId: allocItem.id,
                                orderFlag: allocItem.orderFlag,
                                orderId: allocItem.orderId,
                                orderItemId: allocItem.orderItemId,
                                ioFlag: allocItem.ioFlag,
                                buyerShopId: allocItem.buyerShopId,
                                skuId: allocItem.skuId,
                                goodsId: allocItem.goodsId,
                                srcVendorId: allocItem.srcVendorId,
                                title: allocItem.title,
                                catId: allocItem.catId,
                                catName: allocItem.catName,
                                brandId: allocItem.brandId,
                                brandName: allocItem.brandName,
                                wrntPeriod: allocItem.wrntPeriod,
                                quantity: allocItem.quantity,
                                unit: allocItem.unit,
                                desc: allocItem.desc,
                                //
                                cgVoucherId: allocItem.cgVoucherId,
                                cgVoucherItemId: allocItem.cgVoucherItemId,
                                assetDefId: allocItem.assetDefId,
                                asmblAccFlag: allocItem.asmblAccFlag,
                                vendorUknoFlag: true,
                                setupFlag: allocItem.setupFlag,
                                asmblFlag: allocItem.asmblFlag,
                                price: allocItem.price,
                                ntxPrice: allocItem.ntxPrice, // 未税价
                                taxRate: allocItem.taxRate,
                                arriveDays: allocItem.arriveDays
                            };
                            itemList.add(item);
                        }
                        self.shipVoucher.itemList = Utils.merge([], itemList);
                        self.desireArriveDate = desireArriveDate;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择物流公司
            showLogisCom: function () {
                let self = this;
                Vue.$showDialog({
                    title: '选择物流公司',
                    width: 1000,
                    height: 900,
                    template: '<div>' +
                    '<swb-merchant-logis-com-list-for-select :checkBox="false" ref="swb_logis_com_list_for_select"></swb-merchant-logis-com-list-for-select>' +
                    '</div>',
                    data: {},
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_logis_com_list_for_select.getDlgResult() || {};
                        if(result != null && result.type == 'info') {
                            let logisComInfo = result.data;
                            if(!Utils.isNoB(logisComInfo) && logisComInfo.id > 0) {
                                let shipVoucher = self.shipVoucher;
                                shipVoucher.logisComCode = logisComInfo.logisComCode;
                                shipVoucher.logisComName = logisComInfo.logisComName;
                                shipVoucher.logisExpNo = null;
                                self.shipVoucher = Utils.merge({}, shipVoucher);
                            }
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                        return true;
                    },
                    lifecycle: {}
                })
            },

            saveShipVoucher: function () {
                let self = this;
                let goodsShipVoucher = self.shipVoucher;
                let allocFormId = goodsShipVoucher.allocFormId;
                if(Utils.isNoB(allocFormId)) {
                    Toast.show("请选择配货单！");
                    return false;
                }
                // 预计到货日期校验
                let expectArriveDate = goodsShipVoucher.expectArriveDate;
                if(Utils.isNoB(expectArriveDate)) {
                    Toast.show("请选择预计到货日期！");
                    return false;
                }
                goodsShipVoucher.expectArriveDate = expectArriveDate.format("yyyy-MM-dd");
                // 物流单号校验
                if(!Utils.isNoB(goodsShipVoucher.logisComCode)) {
                    if(Utils.isNoB(goodsShipVoucher.logisExpNo)) {
                        Toast.show("请填写物流单号！");
                        return false;
                    }
                    let reg = /^[0-9a-zA-Z]+$/;
                    let regx = /\d+/;
                    if(!reg.test(goodsShipVoucher.logisExpNo) || !regx.test(goodsShipVoucher.logisExpNo)) {
                        Toast.show("物流单号只能是数字或字母和数字组成");
                        return false;
                    }
                }
                //
                let itemList = goodsShipVoucher.itemList;
                if(Utils.isNoB(itemList) || itemList.length <= 0) {
                    Toast.show("沒有商品信息无需发货！");
                    return false;
                } else {
                    for(let i = 0; i < itemList.length; i++) {
                        let item = itemList[i];
                        if(Utils.isNoB(item.wrntPeriod) || !Utils.isNaturalStr(item.wrntPeriod)) {
                            Toast.show("质保期必须为大于等于0的整数!");
                            return false;
                        }
                    }
                }
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.saveGoodsShipVoucherByAllocForm(goodsShipVoucher, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        MsgBox.success("发货单保存成功");
                        //
                        self.goBack();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 返回
            goBack: function () {
                let self = this;
                //
                if(Utils.isNoB(self.orderId)) {
                    self.$router.push({
                        path: SwbGoodsShipVoucherList.path
                    });
                } else {
                    self.$router.push({
                        path: SwbShowGoodsOrder.path,
                        query: {
                            goodsOrderId: self.orderId,
                            cancelledFlag: self.cancelledFlag,
                            activeName: 'third'
                        }
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsShipVoucherAdd.vue